import { cva } from 'class-variance-authority';
export const getCheckboxClasses = cva('reset interactable flex select-none items-center justify-center rounded-sm border border-solid transition-colors duration-150', {
    variants: {
        size: { large: 'size-6', default: 'size-[18px]', small: 'size-[14px]' },
        disabled: { false: 'cursor-pointer', true: 'cursor-default opacity-50' },
        checked: {
            false: 'border-base bg-base',
            true: 'border-super-strong bg-super-strong',
            indeterminate: 'border-super-strong bg-super-strong',
        },
    },
    compoundVariants: [
        { checked: false, disabled: false, class: 'hover:border-base hover:bg-soft' },
        { checked: true, disabled: false, class: 'hover:opacity-80' },
    ],
    defaultVariants: { size: 'default', disabled: false, checked: false },
});
//# sourceMappingURL=classes.js.map